module.exports = __webpack_public_path__ + "img/city-profile2.3314bb10.png";